import React, {useState} from 'react';
import './GetStarted.css';
import capImage from "../../Assets/graduation-cap.jpg";
import { useNavigate } from 'react-router-dom';

function GetStarted() {
    const navigate = useNavigate();
    const [isAccepted, setIsAccepted] = useState(true);

   const handleClick = () => {
    if (isAccepted) {
        navigate('/dashboard', { state: { showVouchers: true } });
    }
};


    return (
        <div className="get-started-container">
            <div className="get-started-box">
              <div className='image-wrapper'>
                  <img src={capImage} alt="Graduation Cap" className="get-started-image" />
              </div>
                <h1 className="title">Welcome to EduTest</h1>
                <ul className="feature-list">
                    <li>🎯 Clear Concepts with Guided Lessons</li>
                    <li>📝 Take Interactive Practice Tests</li>
                    <li>📊 View Instant Results and Feedback</li>
                    <li>🏆 Track Your Progress Over Time</li>
                </ul>


                {/* terms and condition section */}
                <div className='terms-section'>
                    <h3>Terms & Conditions</h3>
                    <p>
                        By continuing, you agree to the following:
                        <br /><br />
                        - You will not share your login credentials with others. <br />
                        - You will use this platform only for personal learning. <br />
                        - Any misuse may result in suspension of your access. <br />
                        - Data may be used for improving educational recommendations. <br />
                        - You agree to receive occasional communication from EduTest. <br/>

                         - You will not share your login credentials with others. <br />
                        - You will use this platform only for personal learning. <br />
                        - Any misuse may result in suspension of your access. <br />
                        - Data may be used for improving educational recommendations. <br />
                        - You agree to receive occasional communication from EduTest. <br/>

                         - You will not share your login credentials with others. <br />
                        - You will use this platform only for personal learning. <br />
                        - Any misuse may result in suspension of your access. <br />
                        - Data may be used for improving educational recommendations. <br />
                        - You agree to receive occasional communication from EduTest. <br/>
                    </p>

                    <div className="checkbox-container">
                        <input
                            type="checkbox"
                            id="accept"
                            checked={isAccepted}
                            onChange={() => setIsAccepted(!isAccepted)}
                        />
                        <label htmlFor="accept">I accept the terms and conditions</label>
                    </div>
                </div>
            
                <button
                    className="get-started-button"
                    onClick={handleClick}
                    disabled={!isAccepted}
                >
                    Get Started
                </button>
            </div>
        </div>
    );
}

export default GetStarted;
